/* Copyright (c) 2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { InjectionToken } from '@angular/core';
import { ProxyConfigType } from './proxy.config';

export const PROXY_CONFIG: InjectionToken<ProxyConfigType> = new InjectionToken('PROXY_CONFIG');
